<template>
  <div class="login-bg">
    <button
      type="button"
      class="auth-home-btn"
      aria-label="Home"
      @click="$router.push('/home')"
    >
      <i class="fas fa-home"></i>
    </button>
    <div class="login-cont container">
      <div class="d-flex justify-content-center h-100">
        <div class="col-12 px-0 d-flex flex-column my-auto">
          <img
            class="mx-auto mb-4"
            src="@/assets/logo2.png"
            alt="ThinKaHa"
            @click="$router.push('/home')"
            style="height: 10rem"
          />
          <!-- <div class="card border-0 mb-0 auth-card bg-transparent"> -->
          <div
            class="card-body px-2 d-flex mx-0 col-12 mx-auto"
            style="background: rgba(18, 16, 28, 0.78);border-radius: 16px;box-shadow: 0 8px 32px rgba(0, 0, 0, 0.45);backdrop-filter: blur(12px);-webkit-backdrop-filter: blur(12px);border: 1px solid rgba(232, 197, 71, 0.35);"
          >
            <div class="my-auto col-12">
              <div class="text-center mb-4">
                <div
                  class="error text-center py-2"
                  v-if="error"
                >
                  <span class="mx-auto">
                    {{ $t('auth.fail_message') }}
                  </span>

                </div>
              </div>
              <form role="form">
                <small class="text-dark">{{ errors.phone }}</small>
                <div class="form-group mb-3">
                  <label style="color: #E8C547; font-weight: 550; letter-spacing: 0.5px;">{{ $t('auth.phone') }}</label>
                  <!-- <div
                      class="input-group input-group-merge input-group-alternative bg-transparent"
                    > -->
                  <input
                    class="form-control pl-2 px-4"
                    style="background: linear-gradient(180deg, #fff8e7 0%, #ffffff 100%) !important; color: #1a1212; box-shadow: none; border-radius: 8px; border: 1px solid rgba(245, 197, 24, 0.45); font-size: 1.2rem;"
                    type="text"
                    v-model="name"
                    @keyup.enter="focusOnPasswordInputBox"
                  />
                  <!-- </div> -->
                </div>
                <small class="text-dark">{{ errors.password }}</small>
                <div class="form-group pt-3">
                  <label style="color: #E8C547; font-weight: 550; letter-spacing: 0.5px;">{{ $t('auth.password')
                  }}</label>
                  <!-- <div
                      class="input-group input-group-merge input-group-alternative"
                    > -->
                  <div class="input-group">
                    <input
                      class="form-control pl-2 px-4"
                      style="background: linear-gradient(180deg, #fff8e7 0%, #ffffff 100%) !important; color: #1a1212; box-shadow: none; border-radius: 8px; border: 1px solid rgba(245, 197, 24, 0.45); font-size: 1.2rem;"
                      type="password"
                      ref="password"
                      v-model="password"
                      @keyup.enter="loginWithPhone"
                    />
                    <i
                      class="far fa-eye showable-password"
                      style="color: #E8C547;"
                      v-if="isShow"
                      @click="showablePassword()"
                    ></i>
                    <i
                      v-if="!isShow"
                      class="fas fa-eye-slash showable-password"
                      style="color: #E8C547;"
                      @click="showablePassword()"
                    ></i>
                  </div>
                  <!-- </div> -->
                </div>
                <div class="text-center mt-3">
                  <button
                    type="button"
                    class="btn my-4"
                    style="background: linear-gradient(135deg, #FA610B 0%, #F88D14 100%); color: #fff; border-radius: 20px; width: 10rem; box-shadow: 0 4px 14px rgba(231, 98, 41, 0.4); border: 1px solid rgba(232, 197, 71, 0.4);"
                    @click="loginWithPhone()"
                  >
                    <div v-if="!isSignin">
                      {{ $t('auth.login') }}
                    </div>

                    <Loading
                      color="#ffffff"
                      v-if="isSignin"
                      size="24"
                      class="px-4 py-0"
                    />
                  </button>
                </div>
                <div
                  v-if="showQuickLogin"
                  class="text-center mt-1 mb-2"
                >
                  <button
                    type="button"
                    class="btn text-nowrap"
                    style="background: linear-gradient(135deg, #E8C547 0%, #D4B03A 45%, #C5A028 100%); color: #1A1428; border-radius: 20px; min-width: 5.5rem; padding-left: 0.65rem; padding-right: 0.65rem; box-shadow: 0 4px 14px rgba(245, 197, 24, 0.35); font-weight: 600; border: 1px solid rgba(255,255,255,0.2);"
                    @click="quickLogin"
                  >
                    <span v-if="!isQuickLogin">
                      <i class="fas fa-bolt mr-1"></i>{{ $t('auth.quick_login') }}
                    </span>
                    <Loading
                      v-else
                      color="#1A1428"
                      size="20"
                      class="px-2 py-0"
                    />
                  </button>
                </div>
                <div class="col-12 d-flex my-1">
                  <div
                    class="col-5 p-0 my-auto"
                    style="border-top: 1px solid rgba(245, 197, 24, 0.45); height: 0;"
                  ></div>
                  <div
                    class="my-auto px-3"
                    style="color: #E8C547;"
                  >OR</div>
                  <div
                    class="col-5 p-0 my-auto"
                    style="border-top: 1px solid rgba(245, 197, 24, 0.45); height: 0;"
                  ></div>
                </div>
                <div class="text-center mb-3">
                  <button
                    type="button"
                    class="btn my-4"
                    style="background: linear-gradient(135deg, #8B6914 0%, #C5A028 50%, #E8C547 100%); color: #12101C; border-radius: 20px; width: 14rem; box-shadow: 0 4px 14px rgba(201, 162, 39, 0.35); font-weight: 600;"
                    @click="$router.push('/auth/register')"
                  >
                    <div>
                      {{ $t('auth.sign_up') }}
                    </div>
                  </button>
                </div>
                <!-- <div class="d-flex justify-content-center">
                      <span style="color: #ffffff; text-decoration: underline;" @click="$router.push('/auth/not-auth-verify')">Forgot Password?</span>
                    </div> -->
              </form>

              <div class="auth-contact-wrap">
                <p class="auth-contact__hint">
                  {{ $store.state.language === 'en' ? 'Need help?' : 'အကူအညီလိုပါသလား' }}
                </p>
                <div class="row auth-contact-row mx-0">
                  <div class="col-6 auth-contact-col">
                    <a
                      class="auth-contact auth-contact--tile"
                      :href="loginViberHref"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span class="auth-contact__icon auth-contact__icon--viber">
                        <i class="fab fa-viber"></i>
                      </span>
                      <span class="auth-contact__title">Viber</span>
                    </a>
                  </div>
                  <div class="col-6 auth-contact-col">
                    <a
                      class="auth-contact auth-contact--tile auth-contact--telegram"
                      :href="telegramLink(loginTelegram)"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span class="auth-contact__icon auth-contact__icon--telegram">
                        <i class="fab fa-telegram-plane"></i>
                      </span>
                      <span class="auth-contact__title">{{ loginTelegramLabel }}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- </div> -->
          <div class="row mt-3">
            <div class="col-4">
              <div
                class="modal fade"
                id="forgetPassword"
                tabindex="-1"
                role="dialog"
                aria-labelledby="modal-form"
                aria-hidden="true"
              >
                <div
                  class="modal-dialog modal- modal-dialog-centered"
                  role="document"
                >
                  <div class="modal-content">
                    <div class="modal-body p-5">
                      <b>
                        Please direct contact to customer service -
                        <span class="text-dark">09756477723</span>
                      </b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Loading } from 'vant';
import { mapActions, mapMutations } from 'vuex';
import { viberLink, telegramLink } from '@/utils/contactLinks';

export default {
  components: { Loading },
  data() {
    return {
      name: null,
      password: null,
      error: false,
      errors: {},
      isSignin: false,
      isQuickLogin: false,
      isShow: false,
      defaultTelegram: 'https://t.me/ThinKaHaLucky7_bot',
      defaultViber: 'https://msng.link/o?959699959996=vi',
    };
  },
  computed: {
    isPlay2Subdomain() {
      if (typeof window === 'undefined') return false;
      const host = window.location.hostname.toLowerCase();
      return host === 'play2' || host.startsWith('play2.');
    },
    isPlaySubdomain() {
      if (typeof window === 'undefined') return false;
      const host = window.location.hostname.toLowerCase();
      return host === 'play' || host.startsWith('play.');
    },
    showQuickLogin() {
      return this.isPlaySubdomain || this.isPlay2Subdomain;
    },
    playHostPlatform() {
      if (this.isPlay2Subdomain) return 'G';
      if (this.isPlaySubdomain) return 'TikTok';
      return null;
    },
    loginTelegram() {
      return this.$store.state.contactTelegram || this.defaultTelegram;
    },
    loginViberHref() {
      if (this.$store.state.contactInfo) {
        return viberLink(this.$store.state.contactInfo);
      }
      return this.defaultViber;
    },
    loginTelegramLabel() {
      const value = this.loginTelegram;
      if (String(value).startsWith('@')) {
        return value;
      }
      if (String(value).includes('t.me/')) {
        const handle = String(value).split('t.me/').pop().split(/[?#]/)[0];
        return handle ? `@${handle}` : 'Telegram';
      }
      return `@${value}`;
    },
  },
  methods: {
    ...mapActions(['fetchUser']),
    ...mapMutations(['setContactInfo', 'setContactTelegram']),
    telegramLink,
    showablePassword() {
      if (this.isShow) {
        this.$refs.password.type = 'password';
      } else {
        this.$refs.password.type = 'text';
      }
      this.isShow = !this.isShow;
    },
    focusOnPasswordInputBox() {
      this.$refs.password.focus();
    },
    /**
     * login with phone
     */
    async loginWithPhone() {
      this.isSignin = true;
      this.errors = {};
      if (!this.name) {
        this.errors.name = this.$t('auth.require_phone');
        this.isSignin = false;
        return false;
      }
      if (!this.password) {
        this.errors.password = this.$t('auth.require_password');
        this.isSignin = false;
        return false;
      }
      try {
        // if (this.name === 'testuser') {
        //   window.open('https://about.myanmarsoccer.xyz', '_self');
        // } else {
        const res = await this.axios.post(
          '/auth/login',
          {
            phone: this.name,
            password: this.password,
            roles: 'normal',
            fcm: localStorage.getItem('fcm'),
          },
        );
        localStorage.setItem('username', this.name);
        localStorage.setItem('password', this.password);
        localStorage.setItem('token', res.data.token);

        const currentTime = new Date();
        localStorage.setItem(
          'tokenExpire',
          new Date(currentTime.getTime() + 60 * 60 * 1000)
        );
        await this.fetchUser();
        this.$router.push('/home');
        // this.$router.go();
        // ..
        Toast.success(
          this.$store.state.language === 'en'
            ? 'Success!'
            : 'Success!'
        );
        // }
      } catch (err) {
        this.error = true;
      }
      this.isSignin = false;
      return true;
    },
    async quickLogin() {
      this.isQuickLogin = true;
      try {
        const deviceUuid = localStorage.getItem('device_uuid');
        const res = await this.axios.post('/auth/login-with-device', {
          device_uuid: deviceUuid,
        });
        localStorage.setItem('token', res.data.token);
        const currentTime = new Date();
        localStorage.setItem(
          'tokenExpire',
          new Date(currentTime.getTime() + 60 * 60 * 1000)
        );
        this.axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`;
        await this.fetchUser();

        if (res.data.is_first_time === 1) {
          const platform =
            this.playHostPlatform ||
            this.$route.query.ref ||
            this.$route.query.referrer ||
            localStorage.getItem('user_platform_ref');
          if (platform) {
            try {
              await this.axios.post('/auth/update-user-platform', {
                user_platform: platform.toLowerCase(),
              });
            } catch (err) {
              console.error('Failed to update platform via query router param:', err);
            }
          }
        }

        this.$router.push('/home');
        Toast.success('Success!');
      } catch (err) {
        Toast.fail(this.$t('auth.fail_message'));
      }
      this.isQuickLogin = false;
    },
    async fetchWebsiteContact() {
      try {
        const res = await this.axios.get('/website-infos');
        const info = res.data.data[0];
        if (!info) return;
        this.setContactInfo(info.contact_info);
        this.setContactTelegram(
          info.telegram_info
          || info.contact_telegram
          || info.telegram
          || info.telegram_link
          || null
        );
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {
    this.fetchWebsiteContact();
    const authUser = await this.fetchUser();
    if (authUser && this.$store.state.authUser.roles === 'normal')
      this.$router.push('/home');
    const userName = localStorage.getItem('username');
    const password = localStorage.getItem('password');
    if (userName && password) {
      this.name = userName;
      this.password = password;
    }
  },
};
</script>

<style scoped>
.login-bg {
  position: relative;
  min-height: 100%;
  width: 100%;
  background-image: url("https://storage.googleapis.com/spacetech2/thingaha/login.avif");
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  background-color: #12101C;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 6rem;
}

.login-cont {
  padding-top: 4.5rem;
  padding-bottom: 2rem;
}

.auth-home-btn {
  position: absolute;
  top: 1rem;
  left: 1rem;
  z-index: 20;
  width: 2.75rem;
  height: 2.75rem;
  border: 1px solid rgba(232, 197, 71, 0.5);
  border-radius: 50%;
  background: linear-gradient(135deg, #1E1A32 0%, #12101C 100%);
  color: #E8C547;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.15rem;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35);
  cursor: pointer;
}

.auth-home-btn:active {
  transform: scale(0.94);
}

.showable-password {
  position: absolute;
  right: 15px;
  top: 15px;
  cursor: pointer;
  z-index: 1000;
}

.new-account-text {
  cursor: pointer;
}

.error {
  margin-bottom: 13px;
  /* height: 40px; */
  display: flex;
  align-items: center;
  color: #fff;
  border: 1px solid rgba(245, 197, 24, 0.45);
  border-radius: 8px;
  padding: 0px 15px;
  background: rgba(231, 98, 41, 0.35);
  /* font-weight: bold; */
}

.auth-card {
  background: #eeecec;
  /* color: black */
}

.auth-contact-wrap {
  margin-top: 1.25rem;
  padding-top: 0.25rem;
}

.auth-contact__hint {
  margin: 0 0 0.65rem;
  text-align: center;
  color: rgba(245, 197, 24, 0.75);
  font-size: 0.78rem;
  font-weight: 500;
}

.auth-contact-row {
  width: 100%;
}

.auth-contact-col {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.auth-contact {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.7rem 0.85rem;
  border-radius: 12px;
  border: 1px solid rgba(245, 197, 24, 0.35);
  background: rgba(255, 255, 255, 0.06);
  text-decoration: none;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.auth-contact--tile {
  flex-direction: column;
  justify-content: center;
  gap: 0.4rem;
  width: 100%;
  min-height: 4.5rem;
  padding: 0.65rem 0.35rem;
  text-align: center;
}

.auth-contact:active {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(245, 197, 24, 0.55);
  text-decoration: none;
}

.auth-contact__title {
  color: #ffffff;
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1.25;
  word-break: break-word;
}

.auth-contact__icon {
  width: 2.35rem;
  height: 2.35rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 1.25rem;
}

.auth-contact__icon--viber {
  background: #7360f2;
  color: #ffffff;
}

.auth-contact__icon--telegram {
  background: #229ed9;
  color: #ffffff;
}
</style>
